import { Component, Inject, OnInit } from '@angular/core';
import { RGuestMessages } from 'model/shared/backend-api-response/rguest-messages';
import { RoomlistService } from 'modules/shared/legacy-bookexpress/services/RoomList.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CommonConfirmationDialogueComponent } from '../common-confirmation-dialogue/common-confirmation-dialogue.component';
import { LegacyBookInitService } from '../../legacy-bookexpress/services/legacy-book-initializer.service';
import { ToastrService } from 'ngx-toastr';
import { ReservationService } from '../../legacy-bookexpress/services/reservation.service';
import { ModifyReservationsService } from 'modules/shared/services/modify-reservations.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Permissions } from 'model/shared/backend-api-response/permissions';
@Component({
  selector: 'app-modify-reservations',
  templateUrl: './modify-reservations.component.html',
  styleUrls: ['./modify-reservations.component.scss'],
})
export class ModifyReservationsComponent implements OnInit {
  public rGuestBookMessages: RGuestMessages;
  public currentStepCount = 1;
  public maxStepCount = 4; // 1-room slection, 2-guest details, 3-payment, 4-comparison
  public loaderMsg = '';
  rGuestBookPermissions: Permissions;
  resGuestInfo: any;

  constructor(
    public roomService: RoomlistService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ConfigService: LegacyBookInitService,
    public resService: ReservationService,
    public modifiyResService: ModifyReservationsService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.rGuestBookPermissions = ConfigService.PropertyData.permissions;
  }

  ngOnInit(): void {
    this.resGuestInfo = this.resService?.reservationData?.guestInfo?.[0] || {};
    this.rGuestBookMessages = this.ConfigService.PropertyData.rGuestMessages;
  }

  skipCardPayment() {
    if (this.resGuestInfo?.cardLast4) {
      this.modifiyResService.updatedRoom[0].cardDetails = {
        cardLast4: this.resGuestInfo?.cardLast4,
        cardTypeDesc: this.resGuestInfo?.cardTypeDesc,
        cardTypeCode: this.resGuestInfo?.cardTypeCode,
        cardIcon: this.modifiyResService.setCardIcon(this.resGuestInfo?.cardTypeCode),
        isNewCard: false,
      };
    } else {
      delete this.modifiyResService.updatedRoom[0].cardDetails;
      this.modifiyResService.updatedRoom[0].currency = this.data?.currencyDetails?.currencyCode || 'USD';
    }
  }
  updateStepsNavigation(stepCount) {
    if (stepCount === -1) {
      if (
        (!this.rGuestBookPermissions.functionalPermissions.rGuestPayIframe ||
          !this.resService?.reservationData?.canBeAllowedToModify?.[0]?.paymentMethod) &&
        this.currentStepCount === 4
      ) {
        this.currentStepCount = this.currentStepCount - 2;
        this.skipCardPayment();
      } else {
        this.currentStepCount = this.currentStepCount - 1;
      }
      return false;
    }
    if (this.currentStepCount === this.maxStepCount) {
      this.updateReservations();
      return false;
    }
    switch (this.currentStepCount) {
      case 1: {
        //Room selection validations
        if (!this.modifiyResService.updatedRoom.length) {
          this.toastr.error(this.ConfigService?.PropertyData?.rGuestMessages?.groups?.selectRoomErrorMessage);
          return false;
        }
        if (this.modifiyResService.inValidModifyRoomSelection) {
          this.toastr.error(this.modifiyResService.inValidModifyRoomSelection);
          return false;
        }
        break;
      }
      case 2: {
        //Guest Details Validations
        this.resService.checkValidateFIelds.next(true);
        let formElement = $('#guestDetailsForm')[0] as HTMLFormElement;
        if (formElement !== undefined && !formElement?.checkValidity()) {
          this.toastr.error(this.ConfigService?.PropertyData?.rGuestMessages?.groups?.guestInfoMandatoryFieldErrorMessage);
          return false;
        }
        break;
      }
      case 3: {
        //payment Validation
        if (
          (!this.modifiyResService.updatedRoom[0].cardDetails?.isNewCard &&
            !this.modifiyResService.updatedRoom[0].cardDetails?.cardLast4) ||
          (this.modifiyResService.updatedRoom[0].cardDetails?.isNewCard && !this.modifiyResService.updatedRoom[0].cardDetails?.token)
        ) {
          this.toastr.error('Add a card to proceed further');
          return false;
        }
      }
    }
    if (this.currentStepCount >= 1 && this.currentStepCount < this.maxStepCount) {
      if (
        (!this.rGuestBookPermissions.functionalPermissions.rGuestPayIframe ||
          !this.resService?.reservationData?.canBeAllowedToModify?.[0]?.paymentMethod) &&
        this.currentStepCount === 2
      ) {
        this.currentStepCount = this.currentStepCount + 2;
        this.skipCardPayment();
      } else {
        this.currentStepCount = this.currentStepCount + stepCount;
      }
    }
  }

  updateReservations() {
    this.loaderMsg = 'Updating Reservation Details';
    const confNo = this.resService.reservationData.confirmationId;
    const lastName = this.resService.reservationData.guestInfo[0].lastName;
    const arrivalDate = moment(this.modifiyResService.updatedRoom[0].arrival).format('YYYY-MM-DD');
    this.modifiyResService.updateResCall().subscribe((res: any) => {
      if (res.Success) {
        this.dialog.closeAll();
        this.loaderMsg = '';
        this.router.navigate([
          `/wbe/res/${this.ConfigService.gettenantId()}/${this.ConfigService.getpropertyId()}/${confNo}/${lastName}/${arrivalDate}`,
        ]);

        // Router change has no effect in this case. So using Subject to refresh reservation details
        if (this.modifiyResService?.updatedRoom?.[0]?.arrival?.getTime() === this.modifiyResService?.oldRoom?.[0]?.arrival?.getTime()) {
          this.resService.refreshReservation.next({
            tenant: this.ConfigService.gettenantId(),
            property: this.ConfigService.getpropertyId(),
            arrdate: arrivalDate,
            confno: confNo,
            lname: lastName,
          });
        }
      } else {
        this.loaderMsg = '';
        this.toastr.error(res.ErrorMessage || 'Something went wrong !');
      }
    });
    return true;
  }

  close() {
    const dialogRef = this.dialog.open(CommonConfirmationDialogueComponent, {
      width: '600px',
      panelClass: 'p-0',
      data: {
        returnSuccessMsg: 'confirm',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirm') {
        this.dialog.closeAll();
      }
    });
  }

  onPaymentSubmit(event) {
    if (event) {
      this.updateStepsNavigation(1);
    }
  }
}
